import { render, staticRenderFns } from "./InboxItem.vue?vue&type=template&id=23829e17&scoped=true"
import script from "./InboxItem.vue?vue&type=script&lang=ts"
export * from "./InboxItem.vue?vue&type=script&lang=ts"
import style0 from "./InboxItem.vue?vue&type=style&index=0&id=23829e17&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23829e17",
  null
  
)

export default component.exports